import API from "@/api.js"
export function permission() {
	let list = [{
			value: "free_personal",
			label: "免费个人版"
		},
		{
			value: "pro_personal",
			label: "个人专业订阅版（进阶 / 高阶）"
		},
		{
			value: "enterprise",
			label: "企业版空间"
		}
	]
	return list
}

//认证密钥
export async function deepseekModel(keyId,keyValue){
	let isModelArr = {
		type: 0,
		code: "密钥未校验"
	}
	try{
		let res=await API.post(API.fileurl.postDeepseekList,{
			keyId:keyId,
			keyValue:keyValue
		})
		if(res?.data?.code==200){
			let data=res.data.data
			if(!data.success){
				isModelArr = {
					type: 10,
					code: "参数不全"
				}
			}else{
				
				if(data.msg==="ok"){
					
					isModelArr = {
						type: 1,
						code: "密钥正常",
						list:data.models
					}
				}else{
					let msg=JSON.parse(data.msg)||{}
					console.log('msg',msg)
					if(msg?.error?.type=='authentication_error'){
						isModelArr = {
							type: 10,
							code: "密钥异常"
						}
					}
				}
			}
			
		}
	}catch(e){
		
	}finally{
		return isModelArr
	}
}


export function capabilities(val){
	const capabilitiesList=[{"value":"Reasoning","label":"深度思考"},{"value":"VU","label":"视觉理解"},{"value":"IG","label":"图片生成"},{"value":"VG","label":"视频生成"},{"value":"ASR","label":"语音识别"},{"value":"TTS","label":"语音合成"},{"value":"ME","label":"多模态向量"},{"value":"Realtime-Omni","label":"实时全模态"},{"value":"Multimodal-Omni","label":"全模态"},{"value":"Realtime-Text-to-Speech","label":"实时语音合成"},{"value":"TG","label":"文本生成"},{"value":"TR","label":"文本向量"},{"value":"Realtime-ASR","label":"实时语音识别"},{"value":"Realtime-Audio-Translate","label":"实时语音翻译"},{"value":"3D-generation","label":"3D 生成"},{"value":"Realtime-Chatting","label":"实时语音对话"}]
	if(val){
	return 	capabilitiesList.find(v=>v.value==val).label
	}else{
		return capabilitiesList
	}
}

export async function Dashscope(modelKeyId,workspaceId,accessKey,modelId,type){
	let isModelArr = {
		type: 0,
		code: "密钥未校验"
	}
	if (type == 'model') {
		isModelArr.code = "模型未校验"
	}
	if(!modelId||modelId==""){
		modelId="qwq-plus"
	}
	try {
	
		let res = {}
		if (type == 'model') {
			res = await API.get(API.fileurl.getModelModelPermissions + `?modelKeyId=${modelKeyId}&modelId=${modelId}`)
		} else {
			res = await API.get(API.fileurl.getModelModelPermissions + `?workspaceId=${workspaceId}&accessKey=${accessKey}&modelId=${modelId}`)
		}
		if (res?.data?.code == 200) {
			let data = JSON.parse(res.data.data) || null
			console.log('dddd', data)
			if (data) {
				if (data?.code == 'InvalidApiKey') {
					isModelArr = {
						type: 10,
						code: "密钥异常"
					}
	
				}else if(data.code==null){
					if(data.output?.permissions[0]?.permissions){
						let permissions=data.output.permissions[0]?.permissions ||null
						if(permissions?.inference==true){
							//有权限
							isModelArr = {
								type: 1,
								code: "密钥正常"
							}
							if(type == 'model'){
								isModelArr = {
									type: 1,
									code: "模型正常"
								}
							}
						}
						if(permissions?.inference==false){
							//无权限
							isModelArr = {
								type: 1,
								code: "密钥正常"
							}
							if(type == 'model'){
								isModelArr = {
									type: 1,
									code: "模型正常"
								}
							}
						}
						if(!permissions){
							isModelArr = {
								type: 1,
								code: "密钥异常"
							}
							if(type == 'model'){
								isModelArr = {
									type: 10,
									code: "模型异常"
								}
							}
						}
						
					}
					
				}
	
			}
		}
		return isModelArr
	} catch (e) {
		return isModelArr
	}
}
export async function VolcResponsesArr(keyId, modelId, type, modelValue) {
	let isModelArr = {
		type: 0,
		code: "密钥未校验"
	}
	if (type == 'model') {
		isModelArr.code = "模型未校验"
	}

	try {

		let res = {}
		if (type == 'model') {
			res = await API.post(API.fileurl.postVolcResponses + `?apiKeyId=${keyId}&callModelId=${modelId}`)
		} else {
			res = await API.post(API.fileurl.postVolcResponses + `?callModelId=${modelId}&modelValue=${modelValue}`)
		}
		if (res?.data?.code == 200) {
			let data = JSON.parse(res.data.data) || null
			console.log('dddd', data)
			if (data) {
				if (data?.error?.code == 'AuthenticationError') {
					isModelArr = {
						type: 10,
						code: "密钥异常"
					}

				}
				if (data?.error?.code == 'ModelNotOpen') {
					isModelArr = {
						type: 10,
						code: "模型未开通"
					}
					if (type != 'model') {
						isModelArr = {
							type: 1,
							code: "密钥正常"
						}
					}

				}
				if (data?.error?.code == 'MissingParameter') {
					isModelArr = {
						type: 1,
						code: "模型已开通"
					}
					if (type != 'model') {
						isModelArr = {
							type: 1,
							code: "密钥正常"
						}
					}

				}
				if(data?.error?.code?.indexOf("InvalidEndpointOrModel")>-1){
					isModelArr = {
						type: 10,
						code: "模型未开通"
					}
					if (type != 'model') {
						isModelArr = {
							type: 1,
							code: "密钥正常"
						}
					}
				}

			}
		}
		return isModelArr
	} catch (e) {
		return isModelArr
	}
}